<table mat-table [dataSource]="getAssets()">
    <ng-container matColumnDef="serial-number">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.serialNumber' | transloco }} </th>
        <td mat-cell *matCellDef="let asset" data-testid="asset-serial-number-text"> {{asset.serialNumber}} </td>
    </ng-container>

    <ng-container matColumnDef="asset-type">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.type' | transloco }} </th>
        <td mat-cell *matCellDef="let asset" data-testid="asset-type-text"> {{ asset.assetTypeID | enumLabel:'assetType' }} </td>
    </ng-container>

    <ng-container matColumnDef="make">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.make' | transloco }} </th>
        <td mat-cell *matCellDef="let asset" data-testid="asset-make-text"> {{asset.make}} </td>
    </ng-container>

    <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.model' | transloco }} </th>
        <td mat-cell *matCellDef="let asset" data-testid="asset-model-text"> {{asset.model}} </td>
    </ng-container>

    <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.year' | transloco }} </th>
        <td mat-cell *matCellDef="let asset" data-testid="asset-year-text"> {{asset.year}} </td>
    </ng-container>

    <ng-container matColumnDef="colour">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.colour' | transloco }} </th>
        <td mat-cell *matCellDef="let asset" data-testid="asset-colour-text"> {{asset.color}} </td>
    </ng-container>

    <ng-container matColumnDef="post-search">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.postRegistrationSearch' | transloco }} </th>
        <td mat-cell *matCellDef="let asset" data-testid="post-registration-search" style="text-align: center;">
            <mat-checkbox [disabled]="true" [(ngModel)]="asset.shouldTriggerPostRegistrationSearch"></mat-checkbox> 
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>